import { EditorView, NodeView } from 'prosemirror-view'

import { Node } from 'prosemirror-model'
import { schema, nodes, StrongNode } from 'prose-core'

import styles_old from './Box.module.scss'
import styles_merged from './Box_merged.module.scss'
import { checkFeatureFlagUserGroup, USERS } from 'utils/featureFlagUserGroups'
import { isDeletion } from 'common/Prose/Plugins/TrackChanges/utils'
import store from 'redux/store'

export class Box implements NodeView {
  dom: HTMLDivElement
  contentDOM: HTMLElement

  constructor(node: Node, readonly view: EditorView, readonly getPos: () => number) {
    this.contentDOM = this.dom = this.createDomNode(node as StrongNode<typeof nodes.box>)
  }

  update(node: Node) {
    if (node.type === schema.nodes.box) {
      this.updateDomNode(node, this.contentDOM)

      return true
    }

    return false
  }

  private createDomNode(node: StrongNode<typeof nodes.box>) {
    const dom = document.createElement('div')

    this.updateDomNode(node, dom)

    return dom
  }

  private updateDomNode(node: Node, dom: HTMLElement) {
    const isAlmanacUserNoDemo = checkFeatureFlagUserGroup([USERS.withAlmanacEmailNoDemo], store.getState().auth?.email)

    if (!isDeletion(node)) {
      const styles = isAlmanacUserNoDemo ? styles_merged : styles_old
      const { boxColor, quoteColor } = node.attrs

      dom.className = ''
      dom.style.background = node.attrs.boxColor || ''
      dom.style.borderLeft = quoteColor ? `3px solid ${quoteColor}` : ''
      if (boxColor) {
        dom.className = styles.box
      }

      if (quoteColor) {
        dom.className = styles.quote
      }

      if (boxColor && quoteColor) {
        dom.className = styles.boxAndQuote
      }
    } else {
      dom.className = ''
      dom.style.background = ''
      dom.style.borderLeft = ''
    }

    for (const attribute in node.attrs) {
      dom.setAttribute(`data-${attribute}`, node.attrs[attribute])
    }
  }
}
